import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/inventorystatus`;

// CREATE =>  POST: add a new product to the server
export function createInventoryStatus(inventoryStatus) {
  return axios.post(API_URL, { ...inventoryStatus });
}

// READ
export function getAllInventoryStatus() {
  return axios.get(API_URL);
}

export function getPaginatedInventoryStatus(queryParams) {
  return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getInventoryStatusById(inventoryStatusId) {
  return axios.get(`${API_URL}/${inventoryStatusId}`);
}

// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the inventoryStatus on the server
export function updateInventoryStatus(inventoryStatusId, inventoryStatus) {
  return axios.put(`${API_URL}/${inventoryStatusId}`, { ...inventoryStatus });
}

// DELETE => delete the product from the server
export function deleteInventoryStatus(inventoryStatusId) {
  return axios.delete(`${API_URL}/${inventoryStatusId}`);
}
